<template>
    <section class="advert-section">
        <div class="advert-container">
            <div class="advert-grids">
                <div class="advert-icon">
                    <svg viewBox="0 0 800 600" xmlns="http://www.w3.org/2000/svg">
                        <!-- Background -->
                        <rect width="800" height="600" fill="#f8fafc" />

                        <!-- Central Shield -->
                        <g transform="translate(400,250)">
                            <path d="M-50,-60 L-50,10 Q-50,30 -30,40 L0,55 L30,40 Q50,30 50,10 L50,-60 Z" fill="#374151"
                                stroke="#374151" stroke-width="2" />

                            <!-- Lock icon -->
                            <g transform="translate(0,-5)">
                                <rect x="-12" y="5" width="24" height="20" rx="2" fill="#ffffff" />
                                <path d="M-8,-10 Q-8,-18 0,-18 Q8,-18 8,-10" fill="none" stroke="#ffffff"
                                    stroke-width="3" />
                            </g>
                        </g>

                        <!-- Simple data blocks -->
                        <g fill="#e2e8f0" stroke="#cbd5e1">
                            <rect x="200" y="200" width="60" height="30" rx="4" />
                            <rect x="200" y="250" width="60" height="30" rx="4" />
                            <rect x="200" y="300" width="60" height="30" rx="4" />

                            <rect x="540" y="200" width="60" height="30" rx="4" />
                            <rect x="540" y="250" width="60" height="30" rx="4" />
                            <rect x="540" y="300" width="60" height="30" rx="4" />
                        </g>

                        <!-- Simple connection lines -->
                        <g stroke="#94a3b8" stroke-width="2" fill="none">
                            <line x1="260" y1="215" x2="350" y2="240" />
                            <line x1="260" y1="265" x2="350" y2="250" />
                            <line x1="260" y1="315" x2="350" y2="260" />

                            <line x1="450" y1="240" x2="540" y2="215" />
                            <line x1="450" y1="250" x2="540" y2="265" />
                            <line x1="450" y1="260" x2="540" y2="315" />
                        </g>

                        <!-- Title -->
                        <text x="400" y="120" text-anchor="middle" font-family="Arial, sans-serif" font-size="32"
                            font-weight="bold" fill="#1e293b">
                            Advanced Tier
                        </text>

                        <text x="400" y="150" text-anchor="middle" font-family="Arial, sans-serif" font-size="18"
                            fill="#64748b">
                            Secure Data Protection
                        </text>

                        <!-- Simple features list -->
                        <g transform="translate(400,400)">
                            <text x="0" y="0" text-anchor="middle" font-family="Arial, sans-serif" font-size="16"
                                fill="#475569">
                                ✓ Cryptographic Protection
                            </text>
                            <text x="0" y="25" text-anchor="middle" font-family="Arial, sans-serif" font-size="16"
                                fill="#475569">
                                ✓ Enterprise Compliance
                            </text>
                            <text x="0" y="50" text-anchor="middle" font-family="Arial, sans-serif" font-size="16"
                                fill="#475569">
                                ✓ Tamper-Evident Records
                            </text>
                        </g>
                    </svg>
                </div>
                <div class="advert-description">
                    <h2 class="title">Integrity That Scales With You</h2>
                    <p class="description">
                        Advanced Tier offers strong data integrity with cryptographic protections ideal for growing
                        enterprises
                        and regulated industries. It ensures your asset records are tamper-evident and
                        verifiable—without adding unnecessary complexity.
                        If you need reliable compliance and performance at scale, Advanced delivers a powerful balance.
                    </p>
                </div>
            </div>
            </div>
    </section>
</template>

<script>
// import SettingsIcon from "@/components/ui/icons/SettingsIcon.vue";
// import AdvertIcon from "@/components/ui/icons/AdvertIcon.vue";
export default {
    name: 'AdvertSection',
    components: {
        // SettingsIcon,
        // AdvertIcon,
    },
}
</script>

<style scoped>
.advert-section {
    background-color: white;
    padding: 64px 16px;
}

.advert-container {
    max-width: 72rem;
    margin: 0 auto;
    padding: 0px 16px;
}

.header {
    text-align: center;
    margin-bottom: 48px;
}

.title {
    font-size: 30px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 16px;
}

.description {
    font-size: 18px;
    color: #4B5563;
    max-width: 768px;
    margin: 0 auto;
}

.advert-grids {
    display: grid;
    grid-template-columns: 1fr;
    gap: 48px;
    /* flex-direction: column; */
}

/* .advert-grid.right {
    background-color: #F9FAFB;
} */

/* .advert-grid {
    padding: 64px 16px;
    display: grid;
    gap: 48px;
} */

.panel {
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    padding: 24px;
}

.panel-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;
}

.icon {
    font-size: 24px;
    color: #9333EA;
}

.panel-title {
    font-size: 18px;
    font-weight: 600;
    color: #1F2937;
    margin-bottom: 0;
}

.settings-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.setting-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    background-color: #F9FAFB;
    border-radius: 8px;
}

.setting-label {
    font-size: 14px;
    color: #374151;
}

.toggle-switch {
    display: flex;
    align-items: center;
    width: 40px;
    height: 24px;
    background-color: #d1d5db;
    border-radius: 9999px;
    cursor: pointer;
}

.toggle-button {
    background-color: #374151;
    width: 1rem;
    height: 1rem;
    display: block;
    border-radius: 50%;
    margin-left: 0.2rem;
}

.color-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
}

.color-block {
    width: 100%;
    height: 80px;
    border-radius: 8px;
}

.color-block.purple {
    background-color: #9333EA;
}

.color-block.blue {
    background-color: #3B82F6;
}

.color-block.green {
    background-color: #10B981;
}

.color-block.red {
    background-color: #EF4444;
}

@media (min-width: 768px) {
    .advert-grids {
        grid-template-columns: 1fr 1fr;
        /* flex-direction: row; */
    }

    /* .advert-grid {
        grid-template-columns: 1fr 1fr;
    } */
}


@media screen and (min-width: 981px) {
    .advert-grids {
        grid-template-columns: 1fr 1fr;
        /* flex-direction: row; */
    }
}

</style>